module.exports = __webpack_public_path__ + "assets/img/25.ec611621.png";